module.exports = "\n<router-outlet>\n\n\n</router-outlet>\n<ngx-loading [show]=\"loading\"></ngx-loading>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main